<template>
  <div>
    <HeadBanner :itemData="$store.state.selected_menu" />
    <Breadcrumb />
    <div class="outer-box">
      <MoreWaysForBanking />
    </div>
    <ServiceSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ServiceSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ServiceSlider')
      "
    />
    <ReasonsSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ReasonsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ReasonsSlider')
      "
    />
    <ProductsSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ProductsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ProductsSlider')
      "
    />
    <UsefulTools
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.usefull_tools.conf')
      "
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.usefull_tools.conf.enabled'
        ) == 1
      "
      :bg="newsCol"
      :firstLook="2.3"
      :ipadLook="1.5"
    />
  </div>
</template>


<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import ServiceSlider from "@/components/ServiceSlider";
import UsefulTools from "@/components/UsefulTools";
import ReasonsSlider from "@/components/ReasonsSlider";
import ProductsSlider from "@/components/ProductsSlider";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";

export default {
  props: {
    itemData: Object,
    required: true,
  },
  data() {
    return {
      newsCol: "whiteCol",
    };
  },
  components: {
    HeadBanner,
    Breadcrumb,
    ServiceSlider,
    UsefulTools,
    ReasonsSlider,
    ProductsSlider,
    MoreWaysForBanking,
  },
};
</script>

<style  scoped>
.outer-box {
  padding-bottom: 90px;
}
.outer-box .mt-144 {
  margin-top: 55px;
}
@media (max-width: 1365px) {
  .outer-box {
    padding-bottom: 60px;
  }
}
@media (max-width: 767px) {
  .outer-box {
    padding-bottom: 30px;
  }
}
</style>
